export function setItem(storage) {
  return function execute(key, data) {
    storage.setItem(key, data);
  };
}

export default setItem(window.localStorage);
